import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium tracking-wide mb-4">
            Kategorien
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-bold">
            Alle OOPBUY Spreadsheet Kategorien
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Durchstöbern Sie alle 14 Produktkategorien und finden Sie genau das, was Sie suchen.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-2xl bg-background-100 overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 hover:shadow-md"
            >
              <div className="relative h-40 sm:h-44 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4 flex flex-col items-center text-center flex-1">
                <div className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center mb-2 group-hover:bg-primary-100 transition-colors">
                  <i className={`${cat.icon} text-foreground-600 group-hover:text-primary-600 text-base transition-colors`}></i>
                </div>
                <h3 className="text-foreground-900 text-sm font-semibold whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-foreground-400 text-xs mt-1 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-primary-500 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>Entdecken</span>
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}